import $ from 'jquery';
import browser from '@openclassrooms/utils/browser';
import OverlayService from 'Services/OverlayService';
import init from '../init';

function ajaxlink() {
  if (!$('.js-pjax').length) {
    return;
  }

  let overlayService;

  $(browser.document).on('click', 'a.js-pjax', function (event) {
    const $this = $(this);
    let container = $this.attr('data-pjax-container');

    overlayService = new OverlayService({
      elementToAttach: $(container),
      loadingCursor: true,
      whiteSemiTransparentBackground: true,
      iconLoader: true,
    });

    $.pjax.click(event, {
      scrollTo: false,
      timeout: 10000,
      container,
    });

    overlayService.open();
  });

  $(browser.document).on('pjax:end', (event) => {
    let modules = $(event.currentTarget.activeElement).attr('data-pjax-modules-refresh');
    let modulesToRefresh = [];

    if (typeof modules !== 'undefined') {
      modules = modules.replace(' ', '');
      modulesToRefresh = modules.split(',');
    }

    init.launch(modulesToRefresh);

    if (overlayService) {
      overlayService.close();
    }
  });
}

export default {
  name: 'ajaxlink',
  init: ajaxlink,
};
